import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Typography,
  Button,
  IconButton,
  TextField,
  Snackbar,
} from "@material-ui/core";
import clsx from "clsx";
import SelectField from "components/inputs/SelectField";
import { Skeleton } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { asTime1, asDate3 } from "utils/text";
import { isMemberPrice } from "utils/shop";
import Alert from "@material-ui/lab/Alert";
import { productSize, productQuantity } from "config/var/user";
export default function EventInfo({ event, productType }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const products = useSelector((state) => state.cart.products);
  const myUser = useSelector((state) => state.auth.user);
  const [errorMessage, setErrorMessage] = useState("");

  const handleAddCart = () => {
    dispatch({
      type: "cart.ADD_PRODUCT",
      payload: { event, count: qty, size: size, productType },
    });
  };
  const [qty, setQty] = useState(1);
  const [size, setSize] = useState(1);
  const decreaseQty = () => {
    if (qty > 1) {
      setQty(qty - 1);
    }
  };

  const increaseQty = () => {
    setQty(qty + 1);
  };

  return (
    <div className={`${classes.root} ${classes.eventDescription} product-list`}>
      <div className={`${classes.itemInfos} item-infos`}>
        <div class="item-img">
          <h6 className={classes.title}>{event?.title}</h6>
        </div>
        <div>
          <Typography
            className={classes.description}
            dangerouslySetInnerHTML={{ __html: event?.description }}
          />
        </div>
        <div className={clsx(classes.sortRoot, classes.selectMain)}>
          <div className={classes.subMain}>
            <span className={classes.lableText}>
              <label className={classes.lableBold}>Date:</label>{" "}
              {event && asDate3(event.start_at)}
            </span>
            <span className={classes.lableText}>
              <label className={classes.lableBold}>Time:</label>{" "}
              {event && asTime1(event.start_at)} EST
            </span>
            <span className={classes.lableText}>
              <label className={classes.lableBold}>Organizer:</label>{" "}
              {event?.organizer}
            </span>
          </div>
        </div>
      </div>
      <Snackbar
        open={errorMessage}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        onClose={(e, r) => {
          if (r == "timeout") setErrorMessage("");
        }}
      >
        <Alert
          severity="error"
          variant="filled"
          onClose={() => setErrorMessage("")}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("xs")]: {
      padding: "0px 40px 26px 40px",
    },
  },
  itemInfos: {
    width: "100%",
  },
  selectMain: {
    marginTop: 30,
  },
  price: {
    marginTop: 6,
    marginBottom: 13,
    fontSize: 18,
    fontWeight: 500,
  },
  memberPrice: {
    color: theme.palette.text.disabled,
    fontSize: 14,
  },
  lableText: {
    display: "block",
    padding: "8px 0px 8px",
  },
  btn: {
    width: "80%",
    fontSize: 14,
    fontWeight: 500,
    textTransform: "capitalize",
    marginTop: 12,
    background: "#05C1FF !important",
    color: "white !important",
  },
  productRoot: {},
  paper: {
    backgroundColor: theme.palette.background.default,
    marginTop: theme.spacing(6),
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: 35,
    marginBottom: 24,
  },
  input: {
    textAlign: "center",
  },
  lableBold: {
    color: "#05c1ff",
    fontWeight: "700",
  },
  submitBtn: {
    marginTop: 2,
    marginLeft: theme.spacing(2),
  },
  select: {
    width: "100%",
  },
  sortRoot: {
    display: "flex",
    alignItems: "left",
  },
  label: {
    fontSize: 16,
    fontWeight: 600,
    marginRight: 10,
  },
  controls: {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    justifyContent: "space-between",
    width: 100,
  },

  controlBtn: {
    background: "#F5F5F5",
    boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.19971)",
    borderRadius: 5,
    width: 24,
    height: 24,
  },
  controlField: {
    width: 30,
    textAlign: "center",
  },
  controlInput: {
    border: 0,
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    textAlign: "center",
  },
  inputRoot: {
    paddingLeft: 14,
    paddingRight: 14,
  },
  productDetail: {
    width: "80%",
  },
  title: {
    fontSize: 22,
  },
  description: {
    fontSize: 15,
  },
  eventDescription: {
    [theme.breakpoints.only("xs")]: {
      paddingLeft: 0,
      paddingRight: 0,
    }
  }
}));
